import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import UpdatedCtrlHolder from 'pods/forms/components/structural/UpdatedCtrlHolder';
import IProps from 'pods/forms/components/formFieldProps.d';

// interface ICaptchaProps {
// 	setToken: (token: string) => string;
// }

const Captcha = ({
	config,
	computed,
	htmlId,
	value,
	getDisplayError,
	ctrlHolderProps,
}: IProps) => {
	const { appendMsg } = config;

	const errorMsg = getDisplayError();
	const { required, disabled } = computed;

	const _ctrlHolderProps = {
		htmlId,
		errorMsg,
		appendMsg,
		value,
		disabled,
		required,
		...ctrlHolderProps,
	};

	return (
		<UpdatedCtrlHolder {..._ctrlHolderProps}>
			<ReCAPTCHA
				// TODO keep this site key in a global file or  - this is a temp test one
				sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
				style={{ marginTop: '24px' }}
				// onChange={(token: string) => setToken(token)}
				// onExpired={() => setToken('')}
			/>
		</UpdatedCtrlHolder>
	);
};

export default Captcha;
